import React, { useEffect, useRef, useState } from "react";
import { FaInstagram, FaTiktok } from "react-icons/fa6";
import rareLogo from "../Assets/logo doc_080732.jpg.jpeg";
import "./Home.css";

const CONTACT_EMAIL = "rarecleanservices@gmail.com";
const DISPLAY_PHONE = "07077868627";
const WHATSAPP_LINK = "https://wa.me/message/2342VYHRLHRGN1";
const INSTAGRAM_LINK = "https://www.instagram.com/rare.c.o/";
const TIKTOK_LINK = "https://www.tiktok.com/@rareclean.co";
const SEO_TITLE =
  "RARE Cleaning Services | Home, Office & Deep Cleaning in Lagos & Port Harcourt";
const SEO_DESCRIPTION =
  "Book trusted home, office, deep cleaning, post-construction cleanup, and Airbnb turnover services in Lagos and Port Harcourt. Get a fast quote on WhatsApp.";

const NAV_LINKS = [
  { href: "#services", label: "Services" },
  { href: "#how", label: "How It Works" },
  { href: "#why", label: "Why Us" },
  { href: "#areas", label: "Service Areas" },
  { href: "#gallery", label: "Gallery" },
  { href: "#faqs", label: "FAQs" },
  { href: "#contact", label: "Contact" },
];

const HERO_IMAGE =
  "https://images.unsplash.com/photo-1522708323590-d24dbb6b0267?auto=format&fit=crop&w=1600&q=80";
const WHY_IMAGE =
  "https://images.unsplash.com/photo-1497366216548-37526070297c?auto=format&fit=crop&w=1300&q=80";
const CTA_IMAGE =
  "https://images.unsplash.com/photo-1497366754035-f200968a6e72?auto=format&fit=crop&w=1600&q=80";

const TRUST_BADGES = [
  "Discreet Teams",
  "Quality Checklist",
  "Fast Quotes",
  "Lagos & Port Harcourt",
];

const SERVICES = [
  {
    title: "Home Cleaning",
    benefit: "Reliable upkeep for spotless living.",
    image:
      "https://images.unsplash.com/photo-1581578731548-c64695cc6952?auto=format&fit=crop&w=900&q=80",
    alt: "Cleaner in a bright living room.",
  },
  {
    title: "Deep Cleaning",
    benefit: "Detail-focused reset for every corner.",
    image:
      "https://images.unsplash.com/photo-1603712725038-e9334ae8f39f?auto=format&fit=crop&w=900&q=80",
    alt: "Cleaning supplies and tools arranged neatly.",
  },
  {
    title: "Move-in/Move-out",
    benefit: "Leave it pristine or move in fresh.",
    image:
      "https://images.unsplash.com/photo-1484154218962-a197022b5858?auto=format&fit=crop&w=900&q=80",
    alt: "Fresh modern kitchen in move-in condition.",
  },
  {
    title: "Office Cleaning",
    benefit: "Corporate-grade cleaning for workplaces.",
    image:
      "https://images.unsplash.com/photo-1497366216548-37526070297c?auto=format&fit=crop&w=900&q=80",
    alt: "Clean premium office interior.",
  },
  {
    title: "Post-Construction",
    benefit: "Dust, debris, and finishing cleanup.",
    image:
      "https://images.unsplash.com/photo-1504307651254-35680f356dfd?auto=format&fit=crop&w=900&q=80",
    alt: "Workers cleaning a newly built interior with construction dust and debris.",
  },
  {
    title: "Airbnb Turnover",
    benefit: "Hotel-standard turnovers for guests.",
    image:
      "https://images.unsplash.com/photo-1590490360182-c33d57733427?auto=format&fit=crop&w=900&q=80",
    alt: "Neatly prepared short-let bedroom.",
  },
];

const HOW_STEPS = [
  {
    title: "Request a Quote",
    description:
      "Send your location, cleaning type, and preferred date on WhatsApp for a fast, transparent quote.",
  },
  {
    title: "Confirm Schedule",
    description:
      "Choose a convenient arrival window for your home, office, short-let, or post-construction cleaning.",
  },
  {
    title: "Cleaning + Quality Check",
    description:
      "Our team completes the job with a checklist-based final inspection before sign-off.",
  },
];

const WHY_POINTS = [
  "Professional, discreet teams trained for premium spaces",
  "Quality checklist on every home and office cleaning visit",
  "Careful handling of delicate surfaces and valuables",
  "Flexible booking windows for busy schedules",
  "Fast WhatsApp response and quote turnaround",
];

const TESTIMONIALS = [
  "Very professional and detailed. Our apartment in Lagos felt brand new after the deep clean.",
  "On-time team, spotless office floors and restrooms, and smooth communication from quote to finish.",
  "Excellent move-out cleaning. The kitchen and bathrooms looked freshly renovated.",
  "Our Airbnb turnovers are now consistent, fast, and guest-ready every single time.",
];

const FAQS = [
  {
    question: "How do you price jobs?",
    answer:
      "Pricing depends on property size, current condition, and service type (standard, deep cleaning, move-in/move-out, office, or post-construction).",
  },
  {
    question: "Do you bring supplies?",
    answer:
      "Yes. Our team can arrive with cleaning supplies and equipment. Let us know if you want eco-friendly products.",
  },
  {
    question: "How long does cleaning take?",
    answer:
      "Timelines vary by space size and cleaning depth. We include an estimated duration in your quote before booking.",
  },
  {
    question: "Do you serve my area?",
    answer:
      "We cover Lagos and Port Harcourt. Send your location on WhatsApp.",
  },
  {
    question: "How do I book?",
    answer:
      "Send us a WhatsApp message or call for a quote, confirm your preferred schedule, and our team takes it from there.",
  },
];

const SERVICE_AREAS = [
  "Lagos",
  "Port Harcourt",
  "Residential estates and apartments",
  "Corporate offices and workspaces",
  "Short-let and Airbnb properties",
];

const GALLERY_IMAGES = [
  {
    src: "https://images.unsplash.com/photo-1505691938895-1758d7feb511?auto=format&fit=crop&w=1200&q=80",
    alt: "High-end living room interior.",
  },
  {
    src: "https://images.unsplash.com/photo-1497366754035-f200968a6e72?auto=format&fit=crop&w=1200&q=80",
    alt: "Premium office workspace.",
  },
  {
    src: "https://images.unsplash.com/photo-1600566752229-250ed79470f8?auto=format&fit=crop&w=1200&q=80",
    alt: "Minimal luxury bedroom.",
  },
  {
    src: "https://images.unsplash.com/photo-1524758631624-e2822e304c36?auto=format&fit=crop&w=1200&q=80",
    alt: "Modern bright dining and lounge area.",
  },
  {
    src: "https://images.unsplash.com/photo-1600607687920-4e2a09cf159d?auto=format&fit=crop&w=1200&q=80",
    alt: "Clean premium hallway and interior.",
  },
  {
    src: "https://images.unsplash.com/photo-1484101403633-562f891dc89a?auto=format&fit=crop&w=1200&q=80",
    alt: "Spotless contemporary bathroom.",
  },
  {
    src: "https://images.unsplash.com/photo-1556911220-bff31c812dba?auto=format&fit=crop&w=1200&q=80",
    alt: "Sparkling modern kitchen.",
  },
  // {
  //   src: "https://images.unsplash.com/photo-1493666438817-866a91353ca9?auto=format&fit=crop&w=1200&q=80",
  //   alt: "Elegant, tidy apartment interior.",
  // },
  {
    src: "https://images.unsplash.com/photo-1595526114035-0d45ed16cfbf?auto=format&fit=crop&w=1200&q=80",
    alt: "Team handling premium cleaning tasks.",
  },
];

const SocialLinks = ({ className = "", onNavigate }) => (
  <div className={`rare-social-links ${className}`.trim()}>
    <a
      href={INSTAGRAM_LINK}
      target="_blank"
      rel="noopener noreferrer"
      className="rare-social-link"
      aria-label="Follow RARE Cleaning Services on Instagram"
      onClick={onNavigate}
    >
      <FaInstagram aria-hidden="true" />
    </a>
    <a
      href={TIKTOK_LINK}
      target="_blank"
      rel="noopener noreferrer"
      className="rare-social-link"
      aria-label="Follow RARE Cleaning Services on TikTok"
      onClick={onNavigate}
    >
      <FaTiktok aria-hidden="true" />
    </a>
  </div>
);

const Header = ({
  whatsappHref,
  phoneHref,
  emailHref,
  isMenuOpen,
  onToggleMenu,
  onCloseMenu,
  menuPanelRef,
  menuButtonRef,
}) => (
  <header className="rare-header">
    <div className="rare-container rare-header-inner">
      <a href="#top" className="rare-brand" onClick={onCloseMenu}>
        <img
          src={rareLogo}
          alt="RARE Cleaning Services logo"
          className="rare-logo"
          loading="eager"
        />
        <div className="rare-brand-copy">
          <span className="rare-brand-title">RARE Cleaning Services</span>
          <span className="rare-brand-tag">Immaculate spaces. Executive standard.</span>
        </div>
      </a>

      <nav className="rare-nav-desktop" aria-label="Primary navigation">
        {NAV_LINKS.map((item) => (
          <a key={item.href} href={item.href}>
            {item.label}
          </a>
        ))}
      </nav>

      <div className="rare-header-actions">
        <a
          href={whatsappHref}
          target="_blank"
          rel="noopener noreferrer"
          className="rare-btn rare-btn-primary rare-header-cta"
        >
          WhatsApp for a Quote
        </a>

        <button
          ref={menuButtonRef}
          type="button"
          aria-label={isMenuOpen ? "Close navigation menu" : "Open navigation menu"}
          aria-controls="mobile-menu"
          aria-expanded={isMenuOpen}
          className={`rare-menu-toggle ${isMenuOpen ? "is-open" : ""}`}
          onClick={onToggleMenu}
        >
          <span />
          <span />
          <span />
        </button>
      </div>
    </div>

    <div className={`rare-mobile-menu-layer ${isMenuOpen ? "is-open" : ""}`} aria-hidden={!isMenuOpen}>
      <div
        className="rare-mobile-menu-backdrop"
        onClick={onCloseMenu}
        aria-hidden="true"
      />
      <aside
        id="mobile-menu"
        ref={menuPanelRef}
        className="rare-mobile-menu"
        role="dialog"
        aria-modal="true"
        aria-label="Mobile site menu"
      >
        <div className="rare-mobile-menu-head">
          <div className="rare-mobile-menu-brand">
            <img src={rareLogo} alt="" loading="lazy" />
            <div>
              <p>RARE Cleaning Services</p>
              <span>Lagos &amp; Port Harcourt</span>
            </div>
          </div>
          <button
            type="button"
            className="rare-mobile-menu-close"
            aria-label="Close mobile menu"
            onClick={onCloseMenu}
          >
            ×
          </button>
        </div>
        <p className="rare-mobile-menu-sub">
          Navigate quickly or request a quote now.
        </p>

        <nav className="rare-mobile-nav" aria-label="Mobile navigation">
          {NAV_LINKS.map((item) => (
            <a key={`mobile-${item.href}`} href={item.href} onClick={onCloseMenu}>
              <span>{item.label}</span>
              <span aria-hidden="true">↗</span>
            </a>
          ))}
        </nav>
        <div className="rare-mobile-menu-contact">
          <a
            href={whatsappHref}
            target="_blank"
            rel="noopener noreferrer"
            className="rare-btn rare-btn-primary rare-mobile-menu-cta"
            onClick={onCloseMenu}
          >
            WhatsApp for a Quote
          </a>
          <a href={phoneHref} className="rare-mobile-call" onClick={onCloseMenu}>
            Call {DISPLAY_PHONE}
          </a>
          <a href={emailHref} className="rare-mobile-call" onClick={onCloseMenu}>
            Email {CONTACT_EMAIL}
          </a>
          <div className="rare-mobile-social-wrap">
            <p className="rare-social-title">Follow us</p>
            <SocialLinks className="rare-social-links-mobile" onNavigate={onCloseMenu} />
          </div>
        </div>
      </aside>
    </div>
  </header>
);

const Hero = ({ whatsappHref, phoneHref }) => (
  <section className="rare-section rare-hero rare-fade" id="top">
    <div className="rare-container">
      <div className="rare-hero-grid">
        <div className="rare-hero-content">
          <div className="rare-kicker-chip">
            <img src={rareLogo} alt="" loading="lazy" />
            <span>RARE Cleaning Services</span>
          </div>
          <p className="rare-kicker">Immaculate spaces. Executive standard.</p>
          <h1>Professional Cleaning Services in Lagos &amp; Port Harcourt</h1>
          <p className="rare-copy">
            RARE Cleaning Services delivers reliable home cleaning, deep cleaning,
            office cleaning, Airbnb turnover, and post-construction cleaning with
            executive-level attention to detail.
          </p>
          <div className="rare-hero-actions">
            <a
              href={whatsappHref}
              target="_blank"
              rel="noopener noreferrer"
              className="rare-btn rare-btn-primary"
            >
              WhatsApp for a Quote
            </a>
            <a href={phoneHref} className="rare-btn rare-btn-secondary">
              Call Now
            </a>
          </div>
          <div className="rare-trust-grid" aria-label="Trust badges">
            {TRUST_BADGES.map((badge) => (
              <div key={badge} className="rare-trust-badge">
                <span className="rare-trust-icon" aria-hidden="true" />
                <span>{badge}</span>
              </div>
            ))}
          </div>
        </div>

        <figure className="rare-hero-image-wrap">
          <img
            src={HERO_IMAGE}
            alt="Premium cleaned luxury apartment interior."
            loading="eager"
            decoding="async"
          />
        </figure>
      </div>
    </div>
  </section>
);

const Services = () => (
  <section id="services" className="rare-section rare-fade">
    <div className="rare-container">
      <div className="rare-heading-group">
        <p className="rare-overline">Services</p>
        <h2>Executive-level cleaning across home and business spaces</h2>
      </div>
      <div className="rare-service-grid">
        {SERVICES.map((service) => (
          <article className="rare-card rare-service-card" key={service.title}>
            <div className="rare-service-thumb">
              <img src={service.image} alt={service.alt} loading="lazy" decoding="async" />
            </div>
            <h3>{service.title}</h3>
            <p>{service.benefit}</p>
          </article>
        ))}
      </div>
    </div>
  </section>
);

const HowItWorks = () => (
  <section id="how" className="rare-section rare-section-soft rare-fade">
    <div className="rare-container">
      <div className="rare-heading-group">
        <p className="rare-overline">How It Works</p>
        <h2>Simple process, premium result</h2>
      </div>
      <div className="rare-step-grid">
        {HOW_STEPS.map((step, index) => (
          <article className="rare-card rare-step-card" key={step.title}>
            <span className="rare-step-pill">Step {index + 1}</span>
            <h3>{step.title}</h3>
            <p>{step.description}</p>
          </article>
        ))}
      </div>
    </div>
  </section>
);

const WhyUs = () => (
  <section id="why" className="rare-section rare-fade">
    <div className="rare-container rare-why-layout">
      <div>
        <div className="rare-heading-group">
          <p className="rare-overline">Why RARE</p>
          <h2>Built for privacy, consistency, and quality</h2>
        </div>
        <ul className="rare-why-list">
          {WHY_POINTS.map((point) => (
            <li key={point}>{point}</li>
          ))}
        </ul>
      </div>
      <figure className="rare-why-image">
        <img src={WHY_IMAGE} alt="Premium office setting maintained at corporate standards." loading="lazy" decoding="async" />
      </figure>
    </div>
  </section>
);

const ServiceAreas = () => (
  <section id="areas" className="rare-section rare-section-soft rare-fade">
    <div className="rare-container">
      <div className="rare-heading-group">
        <p className="rare-overline">Service Areas</p>
        <h2>Trusted cleaning teams across Lagos and Port Harcourt</h2>
      </div>
      <p className="rare-copy">
        We provide scheduled and one-off cleaning services for homes, offices, and
        short-let properties. Share your location and service type, and we will
        confirm availability quickly.
      </p>
      <ul className="rare-area-list" aria-label="Primary service coverage areas">
        {SERVICE_AREAS.map((area) => (
          <li key={area}>{area}</li>
        ))}
      </ul>
    </div>
  </section>
);

const Gallery = () => (
  <section id="gallery" className="rare-section rare-section-soft rare-fade">
    <div className="rare-container">
      <div className="rare-heading-group">
        <p className="rare-overline">Gallery</p>
        <h2>Premium spaces cleaned to executive standards</h2>
      </div>
      <div className="rare-gallery-grid">
        {GALLERY_IMAGES.map((image, index) => (
          <figure className="rare-gallery-card" key={`gallery-${index}`}>
            <img src={image.src} alt={image.alt} loading="lazy" decoding="async" />
          </figure>
        ))}
      </div>
    </div>
  </section>
);

const Testimonials = () => (
  <section className="rare-section rare-fade">
    <div className="rare-container">
      <div className="rare-heading-group">
        <p className="rare-overline">Testimonials</p>
        <h2>What clients say</h2>
        <p className="rare-sample-note">Sample testimonials</p>
      </div>
      <div className="rare-testimonial-grid">
        {TESTIMONIALS.map((quote) => (
          <blockquote className="rare-card rare-testimonial-card" key={quote}>
            <p>"{quote}"</p>
          </blockquote>
        ))}
      </div>
    </div>
  </section>
);

const Faq = ({ openFaqIndex, setOpenFaqIndex }) => (
  <section id="faqs" className="rare-section rare-section-soft rare-fade">
    <div className="rare-container">
      <div className="rare-heading-group">
        <p className="rare-overline">FAQs</p>
        <h2>Everything you need before booking</h2>
      </div>
      <div className="rare-faq-list">
        {FAQS.map((faq, index) => {
          const isOpen = openFaqIndex === index;
          return (
            <article className="rare-faq-item" key={faq.question}>
              <button
                type="button"
                className="rare-faq-question"
                aria-expanded={isOpen}
                aria-controls={`faq-answer-${index}`}
                id={`faq-question-${index}`}
                onClick={() => setOpenFaqIndex(isOpen ? -1 : index)}
              >
                <span>{faq.question}</span>
                <span className="rare-faq-icon" aria-hidden="true">
                  {isOpen ? "-" : "+"}
                </span>
              </button>
              <div
                id={`faq-answer-${index}`}
                role="region"
                aria-labelledby={`faq-question-${index}`}
                className={`rare-faq-answer-wrap ${isOpen ? "is-open" : ""}`}
              >
                <div className="rare-faq-answer-content">
                  <p>{faq.answer}</p>
                </div>
              </div>
            </article>
          );
        })}
      </div>
    </div>
  </section>
);

const FooterCTA = ({ whatsappHref, phoneHref, emailHref }) => (
  <section id="contact" className="rare-section rare-fade">
    <div className="rare-container">
      <div
        className="rare-contact-cta"
        style={{
          backgroundImage: `linear-gradient(132deg, rgba(32, 51, 65, 0.95), rgba(32, 51, 65, 0.82)), url(${CTA_IMAGE})`,
        }}
      >
        <p className="rare-kicker">Immaculate spaces. Executive standard.</p>
        <h2>Get a cleaning quote in minutes</h2>
        <p className="rare-copy">
          Home, office, deep cleaning, and short-let turnover services in Lagos
          &amp; Port Harcourt.
        </p>
        <div className="rare-hero-actions">
          <a
            href={whatsappHref}
            target="_blank"
            rel="noopener noreferrer"
            className="rare-btn rare-btn-light"
          >
            WhatsApp for a Quote
          </a>
          <a href={phoneHref} className="rare-btn rare-btn-outline-light">
            Call Now
          </a>
        </div>
        <p className="rare-contact-phone">Call: {DISPLAY_PHONE}</p>
        <p className="rare-contact-phone">
          Email: <a href={emailHref}>{CONTACT_EMAIL}</a>
        </p>
      </div>
    </div>
  </section>
);

const Footer = ({ whatsappHref, phoneHref, emailHref, footerRef }) => {
  const year = new Date().getFullYear();

  return (
    <footer className="rare-footer" ref={footerRef}>
      <div className="rare-container">
        <div className="rare-footer-shell">
          <div className="rare-footer-shell-copy">
            <p className="rare-footer-links-title">Need a fast quote?</p>
            <h3>Book premium cleaning with a quick WhatsApp message</h3>
          </div>
          <div className="rare-footer-mini-actions">
            <a
              href={whatsappHref}
              target="_blank"
              rel="noopener noreferrer"
              className="rare-footer-mini-btn"
            >
              WhatsApp Quote
            </a>
            <a href={phoneHref} className="rare-footer-mini-btn">
              Call Now
            </a>
            <a href={emailHref} className="rare-footer-mini-btn rare-footer-mini-btn-full">
              Email Us
            </a>
          </div>
        </div>

        <div className="rare-footer-grid">
          <div className="rare-footer-brand">
            <img src={rareLogo} alt="RARE Cleaning Services logo" loading="lazy" />
            <div>
              <p>RARE Cleaning Services</p>
              <p>
                Professional home and office cleaning company serving Lagos and
                Port Harcourt.
              </p>
            </div>
            <div className="rare-footer-contact-lines">
              <a href={phoneHref}>Call: {DISPLAY_PHONE}</a>
              <a href={emailHref}>Email: {CONTACT_EMAIL}</a>
            </div>
          </div>

          <div className="rare-footer-inner">
            <p className="rare-footer-links-title">Quick links</p>
            <div className="rare-footer-links">
              {NAV_LINKS.map((item) => (
                <a key={`footer-${item.href}`} href={item.href}>
                  {item.label}
                </a>
              ))}
            </div>
          </div>

          <div className="rare-footer-inner">
            <p className="rare-footer-links-title">Popular services</p>
            <div className="rare-footer-links">
              {SERVICES.map((service) => (
                <a key={`footer-service-${service.title}`} href="#services">
                  {service.title}
                </a>
              ))}
            </div>
          </div>

          <div className="rare-footer-inner">
            <p className="rare-footer-links-title">Service coverage</p>
            <div className="rare-footer-links">
              {SERVICE_AREAS.slice(0, 3).map((area) => (
                <a key={`footer-area-${area}`} href="#areas">
                  {area}
                </a>
              ))}
            </div>
          </div>
        </div>

        <div className="rare-footer-social-row">
          <div className="rare-footer-social">
            <p className="rare-social-title">Follow us</p>
            <SocialLinks className="rare-social-links-footer" />
          </div>
          <p className="rare-footer-note">
            © {year} RARE Cleaning Services · Premium cleaning in Lagos &amp; Port Harcourt
          </p>
        </div>
      </div>
    </footer>
  );
};

const StickyCTA = ({ whatsappHref, phoneHref }) => (
  <div className="rare-mobile-cta-bar" role="region" aria-label="Quick contact actions">
    <a href={whatsappHref} target="_blank" rel="noopener noreferrer" className="rare-btn rare-btn-primary">
      WhatsApp
    </a>
    <a href={phoneHref} className="rare-btn rare-btn-secondary">
      Call Now
    </a>
  </div>
);

const Home = () => {
  const [openFaqIndex, setOpenFaqIndex] = useState(0);
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isFooterInView, setIsFooterInView] = useState(false);
  const menuPanelRef = useRef(null);
  const menuButtonRef = useRef(null);
  const footerRef = useRef(null);

  const whatsappHref = WHATSAPP_LINK;
  const phoneHref = `tel:${DISPLAY_PHONE}`;
  const emailHref = `mailto:${CONTACT_EMAIL}`;

  const closeMenu = () => setIsMenuOpen(false);

  useEffect(() => {
    document.title = SEO_TITLE;

    const ensureMetaTag = (selector, attribute, value, content) => {
      let element = document.querySelector(selector);
      if (!element) {
        element = document.createElement("meta");
        element.setAttribute(attribute, value);
        document.head.appendChild(element);
      }
      element.setAttribute("content", content);
    };

    ensureMetaTag('meta[name="description"]', "name", "description", SEO_DESCRIPTION);
    ensureMetaTag('meta[property="og:title"]', "property", "og:title", SEO_TITLE);
    ensureMetaTag(
      'meta[property="og:description"]',
      "property",
      "og:description",
      SEO_DESCRIPTION
    );
    ensureMetaTag(
      'meta[name="twitter:title"]',
      "name",
      "twitter:title",
      SEO_TITLE
    );
    ensureMetaTag(
      'meta[name="twitter:description"]',
      "name",
      "twitter:description",
      SEO_DESCRIPTION
    );

    let canonicalTag = document.querySelector('link[rel="canonical"]');
    if (!canonicalTag) {
      canonicalTag = document.createElement("link");
      canonicalTag.setAttribute("rel", "canonical");
      document.head.appendChild(canonicalTag);
    }
    canonicalTag.setAttribute("href", `${window.location.origin}/`);

    const schema = {
      "@context": "https://schema.org",
      "@type": "LocalBusiness",
      name: "RARE Cleaning Services",
      image: `${window.location.origin}/rare-cleaning-services-logo.svg`,
      url: `${window.location.origin}/`,
      telephone: DISPLAY_PHONE,
      email: CONTACT_EMAIL,
      areaServed: ["Lagos", "Port Harcourt"],
      sameAs: [INSTAGRAM_LINK, TIKTOK_LINK],
      makesOffer: SERVICES.map((service) => ({
        "@type": "Offer",
        itemOffered: {
          "@type": "Service",
          name: service.title,
          description: service.benefit,
        },
      })),
      mainEntityOfPage: {
        "@type": "WebPage",
        "@id": `${window.location.origin}/`,
      },
    };

    const faqSchema = {
      "@context": "https://schema.org",
      "@type": "FAQPage",
      mainEntity: FAQS.map((faq) => ({
        "@type": "Question",
        name: faq.question,
        acceptedAnswer: {
          "@type": "Answer",
          text: faq.answer,
        },
      })),
    };

    const localBusinessScriptId = "rare-localbusiness-schema";
    const faqScriptId = "rare-faq-schema";

    let localBusinessScript = document.getElementById(localBusinessScriptId);
    if (!localBusinessScript) {
      localBusinessScript = document.createElement("script");
      localBusinessScript.type = "application/ld+json";
      localBusinessScript.id = localBusinessScriptId;
      document.head.appendChild(localBusinessScript);
    }
    localBusinessScript.textContent = JSON.stringify(schema);

    let faqScript = document.getElementById(faqScriptId);
    if (!faqScript) {
      faqScript = document.createElement("script");
      faqScript.type = "application/ld+json";
      faqScript.id = faqScriptId;
      document.head.appendChild(faqScript);
    }
    faqScript.textContent = JSON.stringify(faqSchema);

    return () => {
      localBusinessScript?.remove();
      faqScript?.remove();
    };
  }, []);

  useEffect(() => {
    const fadeElements = document.querySelectorAll(".rare-fade");
    if (!fadeElements.length) {
      return undefined;
    }

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("is-visible");
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.14 }
    );

    fadeElements.forEach((element) => observer.observe(element));
    return () => observer.disconnect();
  }, []);

  useEffect(() => {
    if (!isMenuOpen) {
      return undefined;
    }

    const handleKeyDown = (event) => {
      if (event.key === "Escape") {
        setIsMenuOpen(false);
      }
    };

    const handleMouseDown = (event) => {
      const menuPanel = menuPanelRef.current;
      const menuButton = menuButtonRef.current;

      if (!menuPanel) {
        return;
      }

      if (menuPanel.contains(event.target) || menuButton?.contains(event.target)) {
        return;
      }

      setIsMenuOpen(false);
    };

    const originalOverflow = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    document.addEventListener("keydown", handleKeyDown);
    document.addEventListener("mousedown", handleMouseDown);

    return () => {
      document.body.style.overflow = originalOverflow;
      document.removeEventListener("keydown", handleKeyDown);
      document.removeEventListener("mousedown", handleMouseDown);
    };
  }, [isMenuOpen]);

  useEffect(() => {
    const footerElement = footerRef.current;
    if (!footerElement) {
      return undefined;
    }

    const observer = new IntersectionObserver(
      ([entry]) => {
        setIsFooterInView(entry.isIntersecting);
      },
      { threshold: 0.2 }
    );

    observer.observe(footerElement);
    return () => observer.disconnect();
  }, []);

  return (
    <div className={`rare-site ${isMenuOpen ? "is-menu-open" : ""}`}>
      <Header
        whatsappHref={whatsappHref}
        phoneHref={phoneHref}
        emailHref={emailHref}
        isMenuOpen={isMenuOpen}
        onToggleMenu={() => setIsMenuOpen((currentState) => !currentState)}
        onCloseMenu={closeMenu}
        menuPanelRef={menuPanelRef}
        menuButtonRef={menuButtonRef}
      />

      <main className="rare-main">
        <Hero whatsappHref={whatsappHref} phoneHref={phoneHref} />
        <Services />
        <HowItWorks />
        <WhyUs />
        <ServiceAreas />
        <Gallery />
        <Testimonials />
        <Faq openFaqIndex={openFaqIndex} setOpenFaqIndex={setOpenFaqIndex} />
        <FooterCTA whatsappHref={whatsappHref} phoneHref={phoneHref} emailHref={emailHref} />
      </main>

      <Footer whatsappHref={whatsappHref} phoneHref={phoneHref} emailHref={emailHref} footerRef={footerRef} />
      <StickyCTA whatsappHref={whatsappHref} phoneHref={phoneHref} />

      <a
        href={whatsappHref}
        target="_blank"
        rel="noopener noreferrer"
        className={`rare-desktop-float ${isFooterInView ? "is-hidden" : ""}`.trim()}
        aria-label="Chat with RARE Cleaning Services on WhatsApp"
      >
        WhatsApp for a Quote
      </a>
    </div>
  );
};

export default Home;
